document.addEventListener('DOMContentLoaded',()=>{
  const t=document.querySelector('.menu-toggle'),m=document.querySelector('[data-mobile-menu]');
  if(t&&m)t.addEventListener('click',()=>m.classList.toggle('is-open'));

  // On mobile the header starts in the normal document flow, then follows the shopper once they scroll past it.
  const mobileHeaderQuery=window.matchMedia('(max-width: 560px)');
  if(mobileHeaderQuery.matches){
    const header=document.querySelector('.site-header');
    if(header){
      let threshold=Math.max(1,header.offsetTop+header.offsetHeight);
      const syncHeader=()=>{
        const floating=window.scrollY>threshold;
        document.body.classList.toggle('aevon-mobile-header-floating',floating);
      };
      const refreshThreshold=()=>{
        if(!document.body.classList.contains('aevon-mobile-header-floating')) threshold=Math.max(1,header.offsetTop+header.offsetHeight);
        syncHeader();
      };
      window.addEventListener('scroll',syncHeader,{passive:true});
      window.addEventListener('resize',refreshThreshold,{passive:true});
      window.addEventListener('orientationchange',refreshThreshold,{passive:true});
      syncHeader();
    }
  }

  // Keep only the dedicated gold Inspired by line; remove duplicate wording inside the mobile description.
  document.querySelectorAll('.product-mobile-description-v10').forEach(box=>{
    box.querySelectorAll('p,li,div').forEach(node=>{
      if(/inspired\s+by/i.test(node.textContent||'')) node.style.display='none';
    });
  });
  const i=document.querySelector('[data-mobile-information]'),b=i?.querySelector('.mobile-information__toggle'),l=i?.querySelector('.mobile-information__links');
  if(b&&l)b.addEventListener('click',()=>{const open=b.getAttribute('aria-expanded')==='true';b.setAttribute('aria-expanded',String(!open));l.hidden=open;i.classList.toggle('is-open',!open)});

  let toastTimer;
  function showAddedToast(title){
    let toast=document.querySelector('[data-aevon-added-toast]');
    if(!toast){
      toast=document.createElement('div');
      toast.className='aevon-added-toast';
      toast.setAttribute('data-aevon-added-toast','');
      toast.setAttribute('role','status');
      toast.setAttribute('aria-live','polite');
      toast.innerHTML='<span class="aevon-added-toast__mark"><span>✓</span></span><span class="aevon-added-toast__copy"><strong>Added to your bag</strong><small></small></span><a href="/cart" class="aevon-added-toast__link">View bag</a>';
      document.body.appendChild(toast);
    }
    const small=toast.querySelector('small');
    if(small) small.textContent=title||'Your AEVON selection has been added.';
    toast.classList.remove('is-visible','is-hiding');
    void toast.offsetWidth;
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer=setTimeout(()=>{
      toast.classList.remove('is-visible');
      toast.classList.add('is-hiding');
    },4200);
  }

  function refreshCartCount(){
    return fetch('/cart.js',{headers:{Accept:'application/json'}}).then(r=>r.ok?r.json():null).then(cart=>{
      if(!cart)return;
      document.querySelectorAll('.cart-count').forEach(c=>c.textContent=cart.item_count);
    }).catch(()=>{});
  }

  document.querySelectorAll('.product-form-v10, .signature-mobile-buy, form[action*="/cart/add"]').forEach(form=>{
    if(form.dataset.aevonAjaxBound==='true')return;
    form.dataset.aevonAjaxBound='true';
    form.addEventListener('submit',async e=>{
      e.preventDefault();
      const button=form.querySelector('[type="submit"]');
      if(!button||button.disabled)return;
      const original=button.innerHTML;
      button.disabled=true;
      button.classList.add('is-adding');
      button.innerHTML='<span class="aevon-add-progress">Adding…</span>';
      try{
        const response=await fetch('/cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});
        if(!response.ok)throw new Error('Cart add failed');
        const item=await response.json();
        await refreshCartCount();
        showAddedToast(item?.product_title||'Your fragrance has been added.');
        button.classList.remove('is-adding');
        button.classList.add('is-added');
        button.innerHTML='<span>Added ✓</span>';
        setTimeout(()=>{button.classList.remove('is-added');button.disabled=false;button.innerHTML=original},1300);
      }catch(err){
        button.classList.remove('is-adding');
        button.disabled=false;
        button.innerHTML=original;
        showAddedToast('Please try again.');
      }
    });
  });

  // Cart quantity controls: update Shopify immediately and keep the cart
  // discount in sync with the current Duo/Trio quantity. Shopify supports
  // discount changes through /cart/update.js, and bundled section rendering
  // lets us replace the server-rendered Order Summary without a page reload.
  let cartUpdateBusy=false;

  function getCartSectionId(){
    const section=document.querySelector('.cart-section-v12');
    return section?.dataset.cartSectionId || null;
  }

  function replaceRenderedCart(html){
    if(!html) throw new Error('Missing rendered cart section');
    const parser=new DOMParser();
    const doc=parser.parseFromString(html,'text/html');
    const fresh=doc.querySelector('.cart-section-v12');
    const current=document.querySelector('.cart-section-v12');
    if(!fresh||!current) throw new Error('Cart section not found');
    current.replaceWith(fresh);
  }

  async function renderCartSection(){
    const sectionId=getCartSectionId();
    if(!sectionId) throw new Error('Cart section ID not found');
    const root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
    const sectionResponse=await fetch(
      root+'cart?section_id='+encodeURIComponent(sectionId),
      {headers:{Accept:'text/html'}}
    );
    if(!sectionResponse.ok) throw new Error('Cart section refresh failed');
    replaceRenderedCart(await sectionResponse.text());
  }

  function isAevonBundleDiscount(cart){
    return (cart?.cart_level_discount_applications||[]).some(application=>{
      const title=String(application?.title||'').toUpperCase();
      return title.includes('AEVON-DUO10') || title.includes('AEVON-TRIO15') || title.includes('DUO10') || title.includes('TRIO15');
    });
  }

  async function syncAevonBundleDiscount(){
    const root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
    const cartResponse=await fetch(root+'cart.js',{headers:{Accept:'application/json'}});
    if(!cartResponse.ok) throw new Error('Cart read failed');
    const cart=await cartResponse.json();
    const itemCount=Number(cart.item_count||0);
    const marker=String(cart?.attributes?._aevon_bundle||'').toUpperCase();
    const hasAevonDiscount=isAevonBundleDiscount(cart);

    let desiredCode='';
    if(itemCount===2) desiredCode='AEVON-DUO10';
    if(itemCount===3) desiredCode='AEVON-TRIO15';

    // Only clear the cart discount when the cart currently carries an AEVON
    // bundle discount/marker. Never wipe a customer's unrelated discount code.
    const shouldClearAevon=!desiredCode && (hasAevonDiscount || marker==='AEVON-DUO10' || marker==='AEVON-TRIO15');
    const currentAevonCode=hasAevonDiscount ? marker : '';
    const needsApply=desiredCode && (!hasAevonDiscount || currentAevonCode!==desiredCode);

    if(!needsApply && !shouldClearAevon) return;

    const payload=needsApply
      ? {discount:desiredCode,attributes:{_aevon_bundle:desiredCode}}
      : {discount:'',attributes:{_aevon_bundle:''}};

    const updateResponse=await fetch(root+'cart/update.js',{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify(payload)
    });
    const updateData=await updateResponse.json();
    if(!updateResponse.ok) throw new Error(updateData?.description||updateData?.message||'Bundle discount update failed');
  }

  async function changeCartLine(line,quantity){
    if(cartUpdateBusy)return;
    cartUpdateBusy=true;
    document.documentElement.classList.add('aevon-cart-updating');
    try{
      const sectionId=getCartSectionId();
      const root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
      const payload={
        line:line,
        quantity:Math.max(0,quantity)
      };

      if(sectionId){
        payload.sections=sectionId;
        payload.sections_url=(window.location.pathname||'/cart')+(window.location.search||'');
      }

      const response=await fetch(root+'cart/change.js',{
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify(payload)
      });
      const data=await response.json();
      if(!response.ok) throw new Error(data.description||data.message||'Cart change failed');

      // First reconcile the bundle discount against the NEW item count.
      // Example: 1 Savage -> quantity 2 applies Duo; Duo -> quantity 3
      // switches to Trio automatically.
      await syncAevonBundleDiscount();

      // Render after the discount mutation so Order Summary receives the
      // final server-calculated totals and discount applications.
      await renderCartSection();
      await refreshCartCount();
    }catch(err){
      console.error('AEVON cart update:',err);
      try{ await renderCartSection(); }catch(_e){}
    }finally{
      cartUpdateBusy=false;
      document.documentElement.classList.remove('aevon-cart-updating');
    }
  }

  document.addEventListener('click',e=>{
    const btn=e.target.closest('[data-cart-minus],[data-cart-plus]');
    if(!btn||!document.querySelector('.cart-section-v12'))return;
    e.preventDefault();
    if(cartUpdateBusy)return;
    const input=document.getElementById(btn.dataset.target);
    if(!input)return;
    const item=input.closest('.cart-item-v12');
    const items=[...document.querySelectorAll('.cart-item-v12')];
    const line=items.indexOf(item)+1;
    const currentQty=parseInt(input.value||'0',10)||0;
    const nextQty=currentQty+(btn.hasAttribute('data-cart-plus')?1:-1);
    if(line<1)return;
    input.value=Math.max(0,nextQty);
    changeCartLine(line,Math.max(0,nextQty));
  });

  document.addEventListener('change',e=>{
    const input=e.target.closest('.cart-item-v12 input[name="updates[]"]');
    if(!input||!document.querySelector('.cart-section-v12'))return;
    const item=input.closest('.cart-item-v12');
    const line=[...document.querySelectorAll('.cart-item-v12')].indexOf(item)+1;
    const quantity=Math.max(0,parseInt(input.value||'0',10)||0);
    if(line>=1)changeCartLine(line,quantity);
  });

});
